import React, { Component } from 'react';
import config from 'config/config';

class DisclaimerAndRights extends Component {
  static displayName = 'DisclaimerAndRights';

  render() {
    var { blog, about, jobs, developers, support, contact, privacy, terms } = config.api.urls;
    return (
      <div className="disclaimer-rights">
        <div className="rights">
          <span className="middle-dot-after">
            Copyright &copy; {`${new Date().getFullYear()} All Rights Reserved.`}
          </span>
          <span>OpenWeb&reg; is a registered trademark.</span>
          <a target="_blank" href={privacy} className="disclaimer-link middle-dot-before">
            Privacy
          </a>
          <a target="_blank" href={terms} className="disclaimer-link middle-dot-before">
            Terms
          </a>
        </div>
      </div>
    );
  }
}

export default DisclaimerAndRights;
